/**
 * CardTypes.js
 */
import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import DynamicComponent from './components/DynamicComponent';
import Player from '@vimeo/player';
import embed from 'embed-video';
import gsap from 'gsap/gsap-core';

export const attachCardTypeContent = ($element, attachElement, type) => {
  const $attachElement = $(attachElement);

  const { 
    cardType,
    videoEmbed,
    hasSound,
    imageSrc,
    imageAlt,
    mobileImageSrc,
    mobileImageAlt,
    poster,
  } = $element.data();

  const isCardModal = type === 'card-modal';

  switch(cardType) {
    case 'code' :
      const scripts = $element.find('code.js').text();
      const styles = $element.find('code.css').text();
      const html = $element.find('code.html').text();

      ReactDOM.render(
        <DynamicComponent
          scripts={scripts}
          styles={styles}
          html={html}
        />
      , attachElement);

      break;
    case 'video' :
      if(!videoEmbed) {
        break;
      }
      let queryOptions = {
        byline: false,
        color: 'F37321',
        playsinline: false,
        portrait: false,
        autoplay: isCardModal,
        title: false,
        muted: !hasSound,
      };
     
      const embedInfo = embed.info(videoEmbed) || {};
      const { source, id, url } = embedInfo;

      if (source === 'vimeo') {
        const $vimeoEl = $('<div class="absolute top-0 left-0 w-full h-full" />');
        $attachElement.append($vimeoEl);

        const player = new Player($vimeoEl[0], {id, url, responsive: true, ...queryOptions});
        player.on('play', (data) => {
          window.currentVimeoPlayer = player;
        });

        if(isCardModal) {
          player.ready().then(() => {
            player.play();
          });
        } else {

          if(!!poster){
            const $posterWrapper = $(`<div class="absolute top-0  flex items-center justify-items-center left-0 w-full h-full" />
            <img src="${poster}" class="object-cover block w-full h-full absolute top-0 left-0" />
            </div>`)
            const $btnPlay = $(`<button type="button" class="relative m-auto amp-icon transition duration-300 ease-in-out rounded-full shadow bg-white hover:bg-orange text-orange hover:text-white w-20" aria-label="Play Video">
            <svg class="stroke-current" viewBox="0 0 108 108" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M44 71L44 37L73 54L44 71Z" fill="transparent" stroke-width="4" stroke-linejoin="round"></path>
            </svg>
            </button>`);
            $posterWrapper.append($btnPlay);

            $btnPlay.on('click', ()=> {
              gsap.to($posterWrapper[0], {autoAlpha: 0, duration: .5});
              player.ready().then(() => {
                player.play();
              });
            })
            $attachElement.append($posterWrapper);
          }
        }

      } else {
        let embedHtml = embed(videoEmbed, { query: queryOptions });
        if(!embedHtml) {
          embedHtml = `<video src='${videoEmbed}' autoplay muted loop playsline />`
        }

        const $embed = $(embedHtml)
        $embed.addClass('w-full h-full');
        $embed.attr('allow', 'autoplay; encrypted-media');
        $attachElement.append($embed);
      }

      break;
    case 'image' :
      let $image = `<img src='${imageSrc}' ${mobileImageSrc ? 'class=\'hidden md:block\'' : ''} alt='${imageAlt}' />`;

      if (mobileImageSrc) $image += `<img src='${mobileImageSrc}' class='featured-mobile-img block md:hidden' alt='${mobileImageAlt}' />`;

      $attachElement.append($image);
      break
    default :
  }
}